import React from "react";

function Https() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-lock-keyhole"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="16" r="1"></circle>
      <rect width="18" height="12" x="3" y="10" rx="2"></rect>
      <path d="M7 10V7a5 5 0 0110 0v3"></path>
    </svg>
  );
}

export default Https;
